





































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Location from '@/models/Location';

const AuthStore = namespace('auth');
const ApplicationStore = namespace('application');
const MagazineStore = namespace('magazine');

@Component({})
export default class LocationDialogComponent extends Vue {

    @AuthStore.Getter('availableLocations')
    public _availableLocations!: Location[];

    get availableLocations(): Location[] {
        // set preset location
        this.selectedLocation = this._availableLocations[0];
        return this._availableLocations;
    }

    @AuthStore.Action('confirmLocation')
    private confirmLocationAction!: (id_location?: string) => Promise<Location>;

    @ApplicationStore.Getter('locationDialog')
    private _locationDialog!: boolean;

    @ApplicationStore.Mutation('setLocationDialog')
    private setLocationDialog!: (value: boolean) => void;

    @MagazineStore.Action('getLocationMagazines')
    private getLocationMagazinesAction!: (locationId?: string) => Promise<any>;

    get locationDialog(): boolean {
        return this._locationDialog;
    }

    set locationDialog(value: boolean) {
        this.setLocationDialog(value);
    }

    public selectedLocation: Location | null = null;

    public async onLocationSelect() {
        try {
            const confirmedLocation = await this.confirmLocationAction(this.selectedLocation?.id);
            await this.getLocationMagazinesAction(confirmedLocation.id);
            this.selectedLocation = null;
            this.locationDialog = false;
        } catch (e) {
            this.$notifyErrorSimplified('LOCALIZATION.ERROR');
        }
    }

    public onLocationSelectCancel() {
        this.selectedLocation = null;
        this.locationDialog = false;
    }
}

